export default "__VITE_ASSET__78e45211__"